import ACTIONS from "../../constatnts"

export const gsetActiveElement = payload => ({
  type: ACTIONS.SET_ACTIVE_ELEMENT,
  payload,
})
